"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeStatus = void 0;
var humanizeStatus = function (status) {
    if (!status) {
        return '';
    }
    return status
        .toString()
        .split('_')
        .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); })
        .join(' ');
};
exports.humanizeStatus = humanizeStatus;
